import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LinkModel, LinkState } from './link.types';
import { serializeLink } from './link.service';
import { serializeRestaurant } from '../restaurant/restaurant.service';

const initialState: LinkState = {
  links: null,
  restaurant: null,
  selectedLink: null,
};

const linkSlice = createSlice({
  name: 'link',
  initialState,
  reducers: {
    validateLinkSuccess: (state, action: PayloadAction<any>) => {
      state.links = (action.payload.links ?? []).map(serializeLink);
      state.restaurant = action.payload.restaurant;
    },
    resetLink: () => initialState,
    selectLink: (state, action: PayloadAction<LinkModel>) => {
      state.selectedLink = action.payload
    },
  }
});

export const {
  validateLinkSuccess,
  resetLink,
  selectLink,
} = linkSlice.actions;

export default linkSlice.reducer;
